var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomeContentLayout',[_c('span',[_vm._v("这是主控台")])])}
var staticRenderFns = []

export { render, staticRenderFns }